import {
  AliceCardFundingFragment,
  EmployerSummaryFragment,
  isNotNull,
  OrganizationDetailFragment,
  PaymentMethodConnectionFragment,
  PaymentMethodFragment,
  PaymentMethodStatus,
} from '@alice-financial/alice-sdk'

const CONNECTED_STATUSES = [
  PaymentMethodStatus.Active,
  PaymentMethodStatus.PendingMandateAcceptance,
  PaymentMethodStatus.PendingSetup,
]
const CONNECTABLE_STATUSES = [PaymentMethodStatus.Active, PaymentMethodStatus.PendingMandateAcceptance]

export const isCurrentPaymentMethodConnection = (pmc: PaymentMethodConnectionFragment) => pmc.isCurrent

export const getCurrentPaymentMethodConnection = (aliceCardFunding: AliceCardFundingFragment) =>
  (aliceCardFunding.paymentMethodConnections || []).find(isCurrentPaymentMethodConnection)

export const isPaymentMethodActive = (pmc: PaymentMethodConnectionFragment | null | undefined) =>
  Boolean(pmc && CONNECTABLE_STATUSES.includes(pmc.paymentMethod.status))
const isPaymentMethodConnected = (paymentMethod: PaymentMethodFragment) =>
  CONNECTED_STATUSES.includes(paymentMethod.status)
export const isConnectionConnected = (pmc: PaymentMethodConnectionFragment | null | undefined) =>
  Boolean(pmc && isPaymentMethodConnected(pmc.paymentMethod))
export const isPaygroupFundingConnected = (paygroup: EmployerSummaryFragment) =>
  isConnectionConnected(getCurrentPaymentMethodConnection(paygroup.aliceCardFunding))

const allPaygroupsHaveFundingConnected = (paygroups: EmployerSummaryFragment[]) =>
  paygroups.length > 0 && paygroups.every(isPaygroupFundingConnected)
export const isOrgFundingConnected = (org: OrganizationDetailFragment) =>
  org.aliceCardProgram.hasFundingConnected ||
  isConnectionConnected(getCurrentPaymentMethodConnection(org.aliceCardFunding)) ||
  allPaygroupsHaveFundingConnected(org.employers.filter(isNotNull))
export const isConnectable =
  (currentPaymentMethod: PaymentMethodFragment | undefined) => (paymentMethod: PaymentMethodFragment) =>
    currentPaymentMethod?.last4 !== paymentMethod.last4 && CONNECTABLE_STATUSES.includes(paymentMethod.status)
